import Marquee from "react-fast-marquee";

const items = [
  "Biryani",
  "Charcoal Kebabs",
  "Butter Chicken",
  "Tandoori",
  "Fresh Naan",
  "Slow Curries",
  "Seekh Kebab",
  "Chicken Karahi",
];

const MarqueeStrip = () => (
  <div
    data-testid="marquee-strip"
    className="bg-gold text-navy py-5 border-y border-navy/20 overflow-hidden"
  >
    <Marquee speed={32} gradient={false} pauseOnHover>
      {items.map((item, i) => (
        <span key={item} className="flex items-center">
          <span
            className={`font-heading text-2xl sm:text-3xl font-semibold tracking-tight px-6 ${
              i % 2 === 1 ? "italic font-medium" : ""
            }`}
          >
            {item}
          </span>
          <span className="text-navy/50 text-xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);

export default MarqueeStrip;
